import { baseAbdomenSchema, baseBowelSoundsSchema, baseGISymptoms, baseGiClinicalNarrativeSection, baseGiPainSchema, baseWeightChangeSchema, } from '../validations/shared/gastrointestinal';
import { baseGuClinicalNarrativeSection, baseGuDetailsSection } from '../validations/shared/genitourinary';
import { baseLastBowelMovement } from '../validations/shared/last-bowel-movement';
const giSymptomsShape = baseGISymptoms.shape;
const abdomenShape = baseAbdomenSchema.shape;
const bowelSoundsShape = baseBowelSoundsSchema.shape;
const giPainShape = baseGiPainSchema.shape;
const lbmShape = baseLastBowelMovement.shape;
const weightShape = baseWeightChangeSchema.shape;
const giNarrativeShape = baseGiClinicalNarrativeSection.shape;
const guDetailsShape = baseGuDetailsSection.shape;
const guNarrativeShape = baseGuClinicalNarrativeSection.shape;
export function buildGiSymptomsFields({ showVomiting, showGiBleed }) {
    return [
        { key: 'nauseaVomiting', field: giSymptomsShape.nauseaVomiting },
        ...(showVomiting
            ? [
                { key: 'vomitingTimesPerDay', field: giSymptomsShape.vomitingTimesPerDay },
                { key: 'vomitingDaysDuration', field: giSymptomsShape.vomitingDaysDuration },
                { key: 'vomitingCharacteristics', field: giSymptomsShape.vomitingCharacteristics, variant: 'tags' },
            ]
            : []),
        { key: 'bowelHabits', field: giSymptomsShape.bowelHabits, variant: 'tags' },
        { key: 'giBleedingType', field: giSymptomsShape.giBleedingType },
        ...(showGiBleed ? [{ key: 'giBleedingMdNotification', field: giSymptomsShape.giBleedingMdNotification }] : []),
        { key: 'otherGiFindings', field: giSymptomsShape.otherGiFindings },
    ];
}
export function buildAbdomenFields({ showDistended, showRebound, showRigidity }) {
    return [
        { key: 'contour', field: abdomenShape.contour },
        ...(showDistended
            ? [
                { key: 'girth', field: abdomenShape.girth },
                { key: 'ascitesPresent', field: abdomenShape.ascitesPresent },
            ]
            : []),
        { key: 'tenderness', field: abdomenShape.tenderness },
        ...(showRebound ? [{ key: 'tendernessMdNotification', field: abdomenShape.tendernessMdNotification }] : []),
        { key: 'additionalFindings', field: abdomenShape.additionalFindings },
        ...(showRigidity ? [{ key: 'rigidityMdNotification', field: abdomenShape.rigidityMdNotification }] : []),
    ];
}
export const bowelSoundsFields = [
    { key: 'ruq', field: bowelSoundsShape.ruq },
    { key: 'luq', field: bowelSoundsShape.luq },
    { key: 'rlq', field: bowelSoundsShape.rlq },
    { key: 'llq', field: bowelSoundsShape.llq },
];
export const giPainFields = [
    { key: 'ruq', field: giPainShape.ruq },
    { key: 'luq', field: giPainShape.luq },
    { key: 'rlq', field: giPainShape.rlq },
    { key: 'llq', field: giPainShape.llq },
];
export const lbmFields = [
    { key: 'lastBowelMovement', field: lbmShape.lastBowelMovement, formatDate: true },
    { key: 'stoolConsistency', field: lbmShape.stoolConsistency },
    { key: 'stoolColor', field: lbmShape.stoolColor },
    { key: 'stoolAmount', field: lbmShape.stoolAmount },
];
export const weightFields = [{ key: 'change', field: weightShape.change }];
export const giNarrativeFields = [{ key: 'narrative', field: giNarrativeShape.narrative }];
export const guDetailsFields = [
    { key: 'details', field: guDetailsShape.details, variant: 'tags' },
    { key: 'catheter', field: guDetailsShape.catheter },
    { key: 'frSize', field: guDetailsShape.frSize },
    { key: 'balloonSize', field: guDetailsShape.balloonSize },
    { key: 'inserted', field: guDetailsShape.inserted },
    { key: 'date', field: guDetailsShape.date, formatDate: true },
    { key: 'urineColor', field: guDetailsShape.urineColor },
    { key: 'urinaryFrequency', field: guDetailsShape.urinaryFrequency },
];
export const guNarrativeFields = [{ key: 'narrative', field: guNarrativeShape.narrative }];
